const EDIT_PASS_TABLE = {
  admin: true,
  edit: true,
};

export {
  EDIT_PASS_TABLE,
};